import axios from "axios"

export const getShortLink = (longURL: string): Promise<any> => {
  return axios.post("/api/shorten-link", {
    long_url: longURL,
    is_ephemeral: true,
  })
}
